export const API_URL = "https://montenegromice.com/mice-api";
